import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app';
import 'firebase/auth';
import he from 'he'
import { stringContains, simplify } from './helpers/util';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navopen: false,
        filtersopen: false,
        status: '',
        error: '',
        uid: '',
        email: '',
        emailVerified: false,
        isMobile: false,
        jobs: [],
        filteredJobs: []
    },
    mutations: {
        openNav ( state ) {
            state.navopen = true;
        },
        closeNav ( state ) {
            state.navopen = false;
        },

        openFilters ( state ) {
            state.filtersopen = true;
        },
        closeFilters ( state ) {
            state.filtersopen = false;
        },

        setStatus (state, payload) {
            state.status = payload
        },
        setError (state, payload) {
            state.error = payload
        },
        setUid ( state, payload) {
            state.uid = payload
        },
        setEmail ( state, payload) {
            state.email = payload
        },
        setEmailVerified ( state, payload) {
            state.emailVerified = payload
        },
        setIsMobile ( state, val ) {
            state.isMobile = val
        },
        setJobs( state, payload ) {
            state.jobs = payload
        }
    },
    actions: {
        // nav
        toggleNav ( {commit}, op ) {
            if( op === "open" ){
                commit( 'openNav' )
            }else if( op === "close" ){
                commit( 'closeNav' )
            }
        },
        toggleFilters ( {commit}, op ) {
            if( op === "open" ){
                commit( 'openFilters' )
            }else if( op === "close" ){
                commit( 'closeFilters' )
            }
        },
        setInitial ( {commit}, payload ) {
            commit('setUid', payload.uid)
            commit('setEmail', payload.email)
            commit('setEmailVerified', payload.emailVerified)
        },
        // Firebase actions
        signIn ( {commit}, payload ) {
            commit('setStatus', 'loading')
            return firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then( response => {
                    commit('setUid', response.user.uid)
                    commit('setEmail', response.user.email)
                    commit('setEmailVerified', response.user.emailVerified)
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },
        signOut ( {commit} ) {
            commit('setStatus', 'loading')
            firebase.auth().signOut()
                .then( () => {
                    commit('setUid', '')
                    commit('setEmail', '')
                    commit('setEmailVerified', false)
                    commit('setStatus', 'success')
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },
        addJob ( {commit}, payload ) {
            commit('setStatus', 'loading')
            return firebase.firestore().collection( "jobs" ).doc().set( payload )
                .then( () => {
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },
        editJob ( { commit }, { docId, edits } ) {
            commit('setStatus', 'loading')
            // remove docId
            var docRef = firebase.firestore().collection( "jobs" ).doc( docId )

            return docRef
                .update( edits )
                .then( () => {
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch(error => {
                    commit( 'setStatus', 'failure' )
                    commit( 'setError', error.message )
                })
        },
        getJobById ( { commit }, id ) {
            commit('setStatus', 'loading')
            return firebase.firestore().collection( "jobs" )
                .where( "id", "==", parseInt( id ) ) // fetch job by id
                .get()
                .then( querySnapshot => {
                    let job = {};
                    let docId = undefined
                    querySnapshot.forEach( doc => {
                        job = doc.data()
                        docId = doc.id
                    } )
                    var obj = {}
                    obj.job = job
                    obj.docId = docId
                    return obj
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },
        getMyJobs( { commit }, email ) {
            return firebase.firestore().collection( "jobs" )
                .where( "owner", "==", email )
                .get()
                .then( querySnapshot => {
                    let jobs = []
                    querySnapshot.forEach( doc => {
                        jobs.push( doc.data() )
                    })
                    jobs    // sort jobs by created date
                        .sort(function(a, b) { return a.created - b.created })
                        .reverse()
                    commit('setStatus', 'success')
                    commit('setError', null)
                    return jobs
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
            },
        getAllJobs( {commit}) {
            commit('setStatus', 'loading')
            return firebase.firestore().collection( "jobs" )
                .where("expires", ">", parseInt(Date.now()))
                .get()
                .then( querySnapshot => {
                    let jobs = [];
                    querySnapshot.forEach( doc => {
                        jobs.push( doc.data() )
                    } )
                    jobs // sort jobs by created date
                        .sort(function(a, b) { return a.created-b.created })
                        .reverse()
                    commit('setJobs', jobs)
                    commit('setStatus', 'success')
                    commit('setError', null)                 
                })
                .catch(error => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        }
    },
    getters: {
        uid ( state ) {
            return state.user
        },
        emailVerified (state) {
            return state.emailVerified
        },
        email (state) {
            return state.email
        },
        status ( state ) {
            return state.status
        },
        error ( state ) {
            return state.error
        },
        mobile ( state ) {
            return state.isMobile
        },
        loggedIn ( state ) {
            return state.uid !== ''
        },
        jobs ( state ) {
            return state.jobs
        },
        filteredJobList (state) {
            return ( {tags, type, loc, desc, remote} ) => {
                let jobs = [ ...state.jobs]
                jobs = desc   ? jobs.filter( j => {
                    let h = false
                    const sc = stringContains
                    const si = simplify
                    const dd = desc.split( " " )

                    for( let i = 0; i < dd.length; i++ ){
                        let d = si(dd[ i ])
                        if( j.desc    && !h ){ h = sc( si( he.decode( j.desc ) ), d ) }
                        if( j.title   && !h ){ h = sc( si( j.title ), d ) }
                        if( j.city    && !h ){ h = sc( si( j.city ), d ) }
                        if( j.company && !h ){ h = sc( si( j.company ), d ) }
                        return h
                    }
                }) : jobs
                jobs = type   ? jobs.filter( j => j.type[ 0 ] === type ) : jobs
                jobs = loc    ? jobs.filter( j => j.state === loc ) : jobs
                jobs = remote ? jobs.filter( j => j.remote ) : jobs
                jobs = tags   ? jobs.filter( j => tags.filter( t => j.tags.indexOf( t ) >= 0 ).length ) : jobs
                return jobs
            }
        }
    }
})
